import { render, staticRenderFns } from "./PrevProcess.vue?vue&type=template&id=70e13704&"
import script from "./PrevProcess.vue?vue&type=script&lang=js&"
export * from "./PrevProcess.vue?vue&type=script&lang=js&"
import style0 from "./PrevProcess.vue?vue&type=style&index=0&id=70e13704&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports